// node modules
import React, { Fragment } from 'react';
// modules
import { useStore } from 'modules/Stores';
import { observer } from 'mobx-react';

export const QuerySwitch: React.FC<QuerySwitchProps> = observer(
  ({ param, children, defaultComponent: DefaultComponent }) => {
    const {
      location: { search },
    } = useStore('RoutingStore');

    const searchValue = new URLSearchParams(search).get(param);
    const childrenArray = React.Children.toArray(
      children,
    ) as React.ReactElement<QueryRouteProps>[];

    const matchedComponents = childrenArray.filter(
      ({ props: { value } }) => searchValue === value,
    );

    if (!matchedComponents.length && !!DefaultComponent) {
      return <DefaultComponent />;
    }

    return <Fragment>{matchedComponents}</Fragment>;
  },
);

export const QueryRoute: React.FC<QueryRouteProps> = ({
  component: Component,
}) => <Component />;
